// extracted by mini-css-extract-plugin
module.exports = {"template":"batch-update_template_3RKBS"};